import { useAppState } from '../appState';
import { useFeatureFlagWithConditions } from '../feature-flags';
import { useAccountData } from './useAccountData';

export type SolutionTemplateEnvironment = 'CUSTOMIZER' | 'COMPOSER';

const TOOL_TO_TEMPLATE_ENVIRONMENT: Record<number, SolutionTemplateEnvironment> = {
    1: 'CUSTOMIZER',
    2: 'COMPOSER'
};

/**
 * Which solution's template a per-solution settings page (Quote Summary Editor, PDF Preview) edits.
 *
 * Behavior:
 * - If the `newConfiguratorBackoffice` feature flag is disabled for the user, `followsMenu` is false and the
 *   page keeps its Visual Product Customizer / 3D Product Configurator tabs.
 * - If the FF is enabled, the page edits the template of the solution selected in the menu (`lastUsedTool`):
 *   - lastUsedTool=1 → CUSTOMIZER
 *   - lastUsedTool=2 → COMPOSER
 *   - otherwise (Viewer, AI Studio) → null: the solution has no such template.
 */
export const useSolutionTemplateEnvironment = (): { followsMenu: boolean; environment: SolutionTemplateEnvironment | null } => {
    const { state } = useAppState();
    const { userInfo } = useAccountData();
    const isNewConfiguratorBackoffice = useFeatureFlagWithConditions('newConfiguratorBackoffice', {
        userId: (userInfo?.userID || 0).toString()
    });

    return {
        followsMenu: isNewConfiguratorBackoffice,
        environment: TOOL_TO_TEMPLATE_ENVIRONMENT[state.lastUsedTool] ?? null
    };
};
